export default {
  methods: {
    getPaymentTitle (val) {
      const _ = this._
      switch(val) {
        case 'bill':
          return _('Invoice')
        case 'transfer':
          return _('Bank transfer')
        case 'creditcard':
          return _('Credit card (PayPal)')
        case 'paypal':
          return _('PayPal')
        case 'verkkomaksut':
        case 'paytrail':
          return _('Paytrail (legacy)')
        case 'checkout':
          return _('Paytrail')
        case 'cash':
          return _('Pay upon pickup')
        case 'paybyway':
        case 'paybywaychannel':
        case 'bambora':
          return _('Visma Pay')
        case 'netaxept':
          return _('Netaxept')
        case 'paybywayembedded':
          return _('Visma Pay') + ' (' + _('e-payments') + ')'
        case 'admincash':
          return _('Cash') + ' (' + _('admin only') + ')'
        case 'admincard':
          return _('Card') + ' (' + _('admin only') + ')'
        case 'adminnone':
          return _('No charge') + ' (' + _('admin only') + ')'
        case 'stripe':
          return _('Stripe')
        case 'smartum':
          return _('Smartum')
        case 'epassi':
          return _('ePassi')
        case 'edenred':
          return _('Edenred')
        case 'masterpass':
          return _('MasterPass')
        case 'mobilepay':
          return _('MobilePay')
        case 'viva':
          return _('Viva')
        case 'pivo':
          return _('Pivo')
        case 'siirto':
          return _('Siirto')
        case 'virtualcard':
          return _('Virtual card')
        case 'moni':
          return _('MONI')
        case 'alipay':
          return _('Alipay')
        case 'multi':
          return _('Multiple')
        case 'open':
          return _('Open order')
        case 'handoff':
          return _('Kiosk')
        case 'voucher':
          return _('Voucher')
        case 'bokun':
          return _('Bókun')
        case 'gyg':
          return _('GetYourGuide')
        case 'rounding':
          return _('Rounding difference')
        default:
          return _('Unknown')
      }
    }
  }
}